export const DEVTOOLS_ENABLED = Boolean(import.meta.env.DEV)

export const debugLog = (...args: unknown[]) => {
  if (!DEVTOOLS_ENABLED) {
    return
  }

  console.debug('[RPA]', ...args)
}
